/* KURZHARTSCHNELL — KINETIC LAYER (2026). No deps. Honours reduced-motion. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('ff-kinetic');

  function tagTargets() {
    var sel = [
      '.product-grid > li',
      '.collection .title-wrapper',
      '.rich-text__blocks',
      '.banner__content',
      '.multicolumn-card',
      '.footer__content-top .footer-block'
    ].join(',');
    document.querySelectorAll(sel).forEach(function (el, i) {
      if (el.hasAttribute('data-ff-reveal')) return;
      el.setAttribute('data-ff-reveal', '');
      el.style.setProperty('--ff-reveal-delay', (i % 8) * 45 + 'ms');
    });
  }

  function runReveal() {
    var nodes = document.querySelectorAll('[data-ff-reveal]:not([data-ff-shown])');
    if (reduced || !('IntersectionObserver' in window)) {
      return; // no JS animation; elements stay in normal flow, fully visible
    }
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.setAttribute('data-ff-shown', ''); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    nodes.forEach(function (n) {
      var r = n.getBoundingClientRect();
      // Below the fold? hide it now and animate it in on scroll.
      // Already visible on load? leave it fully visible — no jump.
      if (r.top >= vh) {
        n.setAttribute('data-ff-hide', '');
        io.observe(n);
      }
    });
  }

  function initTilt() {
    /* KHS: disabled — the soft 3D tilt fought the hard-cut aesthetic.
       Delete this early return to bring it back. */
    return;
    if (reduced) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('.product-grid .card-wrapper').forEach(function (card) {
      if (card.__ffTilt) return; card.__ffTilt = true;
      var raf = null;
      card.addEventListener('pointermove', function (ev) {
        var r = card.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width - 0.5;
        var py = (ev.clientY - r.top) / r.height - 0.5;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          card.style.setProperty('--ff-tx', (px * 5).toFixed(2) + 'px');
          card.style.setProperty('--ff-ty', (py * 5).toFixed(2) + 'px');
          card.style.setProperty('--ff-rx', (-py * 2).toFixed(2) + 'deg');
          card.style.setProperty('--ff-ry', (px * 2).toFixed(2) + 'deg');
        });
      });
      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--ff-tx', '0px'); card.style.setProperty('--ff-ty', '0px');
        card.style.setProperty('--ff-rx', '0deg'); card.style.setProperty('--ff-ry', '0deg');
      });
    });
  }

  function initProgress() {
    if (document.getElementById('ff-progress')) return;
    var bar = document.createElement('div'); bar.id = 'ff-progress';
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (h > 0 ? (window.scrollY / h) : 0).toFixed(4) + ')';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---- Page transition: fade IN only -------------------------------
     The fade-in on load is pure CSS (failsafe). We deliberately do NOT
     intercept clicks to fade OUT before navigating: on some mobile
     browsers the preventDefault + delayed programmatic navigation was
     swallowing taps, so links appeared dead. Native navigation always
     works, so we leave outgoing clicks completely alone. */
  var _fadeInit = false;
  function initPageFade() {
    if (reduced || _fadeInit) return;
    _fadeInit = true;
    // nothing to do — fade-in is CSS; outgoing links navigate natively
  }

  // restore visibility if user returns via back/forward cache
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      document.documentElement.classList.remove('ff-fade-out');
    }
  });

  /* ---- Marquee announcement bar ------------------------------------
     Fill the track with enough copies of the base unit that it exceeds
     the viewport width, then duplicate the whole filled track once so
     translateX(-50%) loops seamlessly regardless of how short the text
     is. Re-runs on resize. */
  function initMarquee() {
    document.querySelectorAll('.announcement-marquee').forEach(function (bar) {
      var viewport = bar.querySelector('.announcement-marquee__viewport');
      if (!viewport) return;
      var baseUnit = bar.__ffUnit || viewport.querySelector('.announcement-marquee__unit');
      if (!baseUnit) return;
      // keep a pristine copy of the original unit for re-builds
      if (!bar.__ffUnit) bar.__ffUnit = baseUnit.cloneNode(true);

      function build() {
        var unit = bar.__ffUnit.cloneNode(true);
        viewport.innerHTML = '';
        viewport.appendChild(unit);
        var unitWidth = unit.getBoundingClientRect().width;
        if (unitWidth === 0) return;
        var barWidth = bar.getBoundingClientRect().width;
        // how many copies to comfortably exceed one screen width
        var copies = Math.max(2, Math.ceil((barWidth * 1.5) / unitWidth));
        for (var i = 1; i < copies; i++) {
          viewport.appendChild(bar.__ffUnit.cloneNode(true));
        }
        // build the "track" = all copies so far, then duplicate it once
        var trackHTML = viewport.innerHTML;
        viewport.innerHTML = trackHTML + trackHTML;
        bar.classList.add('is-ready');
      }

      build();
      // rebuild on resize (debounced)
      if (!bar.__ffResize) {
        var t;
        bar.__ffResize = function () {
          clearTimeout(t);
          t = setTimeout(build, 200);
        };
        window.addEventListener('resize', bar.__ffResize, { passive: true });
      }
    });
  }

  /* ---- Live "in stock" dot --------------------------------------------
     Turns the green stock caption into a pulsing live indicator.
     Idempotent: removes any existing dot + typed bullet first, so it
     never doubles even if boot() runs multiple times. */
  function initStockDot() {
    var nodes = document.querySelectorAll('.product__text.caption-with-letter-spacing');
    nodes.forEach(function (el) {
      var col = getComputedStyle(el).color;
      var m = col.match(/(\d+),\s*(\d+),\s*(\d+)/);
      if (!m) return;
      var r = +m[1], g = +m[2], b = +m[3];
      var isGreen = g > 90 && r < 90 && b < 90 && g > r && g > b;
      if (!isGreen) return;
      el.querySelectorAll('.ff-live-dot').forEach(function (d) { d.remove(); });
      el.textContent = el.textContent.replace(/^[^\p{L}\p{N}]+/u, '').trim();
      var dot = document.createElement('span');
      dot.className = 'ff-live-dot';
      dot.setAttribute('aria-hidden', 'true');
      el.insertBefore(dot, el.firstChild);
      el.classList.add('ff-has-live-dot');
    });
  }

  /* ---- Text banner wipe reveal --------------------------------------
     Banners are clipped to 0 width in CSS and wiped open left→right
     when they enter the viewport. Failsafe: if IntersectionObserver
     is missing or motion is reduced, reveal immediately. */
  function initBannerWipe() {
    var banners = document.querySelectorAll('.ff-textbanner:not([data-khs-wipe])');
    if (!banners.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      banners.forEach(function (b) {
        b.setAttribute('data-khs-wipe', '');
        b.classList.add('khs-revealed');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('khs-revealed');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });

    banners.forEach(function (b) {
      b.setAttribute('data-khs-wipe', '');
      var r = b.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // already on screen at load → reveal right away, no waiting
      if (r.top < vh && r.bottom > 0) {
        b.classList.add('khs-revealed');
      } else {
        io.observe(b);
      }
    });

    // safety net: nothing stays clipped forever
    setTimeout(function () {
      banners.forEach(function (b) { b.classList.add('khs-revealed'); });
    }, 6000);
  }

  /* ---- Category rail: progress bar + edge fade ----------------------
     The rail is a plain overflow-x list. We inject a slim progress bar
     under it and drop the right-hand fade once the user hits the end,
     so it reads as scrollable instead of accidentally clipped. */
  function initCategoryRail() {
    var rails = document.querySelectorAll(
      '.collection-list-wrapper .collection-list.slider:not([data-khs-rail])'
    );

    Array.prototype.forEach.call(rails, function (rail) {
      rail.setAttribute('data-khs-rail', '');

      var gutter = rail.closest('.slider-mobile-gutter');
      if (!gutter) return;

      // build the progress bar once, right after the rail
      var track = document.createElement('div');
      track.className = 'khs-rail-progress';
      var bar = document.createElement('div');
      bar.className = 'khs-rail-progress__bar';
      track.appendChild(bar);
      gutter.appendChild(track);

      function update() {
        var max = rail.scrollWidth - rail.clientWidth;

        // nothing to scroll: hide the bar and the fade entirely
        if (max <= 4) {
          track.style.display = 'none';
          gutter.classList.add('khs-at-end');
          return;
        }
        track.style.removeProperty('display');

        var ratio = rail.clientWidth / rail.scrollWidth;
        var pct = Math.max(12, Math.min(100, ratio * 100));
        bar.style.width = pct + '%';

        var progress = rail.scrollLeft / max;
        // bar travels the leftover track width, expressed relative to
        // its own width (translateX % is a share of the element itself)
        var travel = ((100 - pct) / pct) * 100;
        bar.style.transform = 'translateX(' + progress * travel + '%)';

        gutter.classList.toggle('khs-at-end', rail.scrollLeft >= max - 4);
      }

      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      // images load late and change scrollWidth
      window.addEventListener('load', update);
      setTimeout(update, 60);
      setTimeout(update, 400);
      update();
    });
  }

  /* ---- Card press-down + guaranteed navigation ----------------------
     The theme only wraps the TITLE in a link, and the stretched-::after
     trick is fragile once transforms create new containing blocks. So we
     make the WHOLE card navigate in JS: find the product URL from the
     card's own anchor and go there on tap. This is independent of any CSS
     overlay, so clicking anywhere — image included — always works.
     Press visuals use .khs-pressed (added on pointerdown, removed on
     up/leave/scroll) so a swipe never leaves a card stuck pressed. */
  /* ---- Card press-down visual only ----------------------------------
     Adds .khs-pressed while the finger is down for the shrink/darken/lift
     look. It does NOT touch navigation at all — the theme's native link
     handles that. Cancelled on move/scroll so a swipe doesn't leave a
     card stuck pressed, and so it never interferes with a tap reaching
     the link underneath. */
  function initCardPress() {
    document.querySelectorAll('.product-grid .card-wrapper').forEach(function (card) {
      if (card.__khsPress) return;
      card.__khsPress = true;

      var sx = 0, sy = 0, down = false;
      card.addEventListener('pointerdown', function (e) {
        down = true; sx = e.clientX; sy = e.clientY;
        card.classList.add('khs-pressed');
      }, { passive: true });

      card.addEventListener('pointermove', function (e) {
        if (down && (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10)) {
          card.classList.remove('khs-pressed');
        }
      }, { passive: true });

      var release = function () { down = false; card.classList.remove('khs-pressed'); };
      ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) {
        card.addEventListener(ev, release, { passive: true });
      });
      window.addEventListener('scroll', release, { passive: true });
    });
  }

  /* ---- Header logo press: reliable on touch (like the cards) -------- */
  function initLogoPress() {
    var logo = document.querySelector('.header__heading-link');
    if (!logo || logo.__khsPress) return;
    logo.__khsPress = true;
    var add = function () { logo.classList.add('khs-pressed'); };
    var rm = function () { logo.classList.remove('khs-pressed'); };
    logo.addEventListener('pointerdown', add, { passive: true });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) {
      logo.addEventListener(ev, rm, { passive: true });
    });
  }

  function boot() { tagTargets(); runReveal(); initTilt(); initProgress(); initPageFade(); initMarquee(); initStockDot(); initBannerWipe(); initCategoryRail(); initCardPress(); initLogoPress(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
